/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * A schema that defines a linked reference to extended Resource representation.
 */
export interface LinkedResourceRef {
    /**
     * The primary and unique identifier of the resource (inside tenant)
     * according to [RFC 4122](https://www.rfc-editor.org/info/rfc4122).
     */
    resourceId: string;
}
